.badgeLabel {
  text-overflow: unset;
  overflow: visible;
}
